<template>
	<template v-if="rangeMode === 'price-consumerPriceGross'">
		{{ getPrice(option) }} €
	</template>
	<template v-else-if="rangeMode === 'milage'">
		{{ getPrice(option) }} Km
	</template>
	<template v-else-if="rangeMode === 'power'">
		{{ getCarPs(option) }} Ps ({{ option }} kW)
	</template>
	<template v-else-if="rangeMode === 'firstRegistration'">
		{{ String(option).slice(0, -2) }}
	</template>
	<template v-else>
		{{ option }}
	</template>
</template>

<script>
export default {
	name: 'RangeFilterOption',
	props: {
		option: {
			type: [String, Number],
		},
		rangeMode: {
			type: String,
			default: 'price-consumerPriceGross',
		},
	},
}
</script>
